import React, { Component } from 'react'
import { gql, graphql, compose } from 'react-apollo'
// import { Row } from 'antd'
import moment from 'moment'
import EventItem from './EventItem/EventItem'
import EventItemRecent from './EventItem/EventItemRecent'
// import FilterBox from './FilterBox'
import './EventItem/styles.css'

import { Container } from '~/styles'
const listEvent = gql`
  query listEvent {
    events {
      _id
      slug
      legacy
      website
      coverUrl
      thumbnailUrl
      hidden
      name {
        en
        th
      }
      code
      startDate
      location
      published
      whiteLabelUrl
    }
  }
`
const clientId = process.env.REACT_APP_CLIENT_ID

class EventListPage extends Component {
  componentWillMount () {}
  render () {
    if (!this.props.data.events) {
      return <div>Loading...</div>
    }
    const events = this.props.data.events.filter(e => !e.hidden || clientId)
    const upcomingEvents = events
      .filter(event => moment().isBefore(event.startDate))
      .filter(event => event.published)
      .slice()
      .sort((a, b) => moment(a.startDate) - moment(b.startDate))

    const finishedEvents = events
      .filter(event => moment().isAfter(event.startDate))
      .slice()
      .sort((a, b) => moment(b.startDate) - moment(a.startDate))
    // if (events) {console.log('events', events)}
    // console.log(events)
    return (
      <Container>
        <div>
          <div className="head-page" />
          <div className="card-wrapper">

            {upcomingEvents.length > 0 && <div className="wrap-upcoming">
              <div className="content content-upcoming">
                <div className="head-topic">
                  {/* <h2 className="head-text">UPCOMING EVENTS</h2> */}
                </div>
                <div>
                  {upcomingEvents.map(event => <EventItem {...event} key={event._id} />)}
                </div>
              </div>
            </div>}
            {finishedEvents.length > 0 && <div className="wrap-recently">
              <div className="content content-recently">
                <div className="head-topic">
                  <h2 className="head-text">RECENTLY FINISHED</h2>
                </div>
                <div>
                  {finishedEvents.map(event => (
                    <EventItemRecent {...event} key={event._id} />
                  ))}
                </div>
              </div>
            </div>}
          </div>
        </div>
      </Container>
    )
  }
}

export default compose(graphql(listEvent))(EventListPage)



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventListPage.js